export default __webpack_public_path__ + "static/media/P500_E_BD.936e4425.pdf";